import request from "@/utils/request";

export function Group(params) {
  return request({
    url: "/Log/List",
    method: "get",
    params
  });
}